import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from "rxjs";
import { SearchAutocompleteComponent } from "../../search-autocomplete/search-autocomplete.component";
import { NbIconModule } from "@nebular/theme";
import { NavigationEnd, RouterLink } from "@angular/router";
import { BaseComponent } from "compob2b-libs";
import { filter, takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-header-mobile',
  imports: [
    SearchAutocompleteComponent,
    NbIconModule,
    RouterLink
  ],
  templateUrl: './header-mobile.component.html',
  styleUrl: './header-mobile.component.scss'
})
export class HeaderMobileComponent extends BaseComponent implements OnInit {
  @Input() sideBarState: string;
  @Input() isShowSearch = false;
  @Input() searchMode: any;
  @Input() currentTitle$: Observable<string>;

  @Output() toggleSidebarEvent = new EventEmitter<void>();
  @Output() toggleSearchEvent = new EventEmitter<void>();
  @Output() navigateEvent = new EventEmitter<void>();


  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.unsubscribe)
    ).subscribe(() => {
      if (this.sideBarState === 'expanded') {
        this.toggleSidebarEvent.emit();
      }
    });
  }

  toggleSidebar(): void {
    this.toggleSidebarEvent.emit();
  }

  toggleSearch(): void {
    this.toggleSearchEvent.emit();
  }

  navigateToMain(): void {
    this.navigateEvent.emit();
  }
}
